import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSHeading } from '@swf/cms';
import type { WidgetFC } from '@swf/core/types/Widget';
import { getStyle } from '@swf/core/utils/casino';

import styles from './AppFooterContentWidget.scss';
import Item from './components/Item';
import { appFooterContentWidgetModel, useAppFooterContentWidget } from './model';

const AppFooterContentWidget: WidgetFC = () => {
  const { widgetSelect } = useAppFooterContentWidget();
  const data = useSelector(widgetSelect.get);
  const backgroundImage = data.background_image.asset?.url;
  const withHeading = data.heading?.title || data.heading?.logged_in_title;

  return data.items.length ? (
    <div className={styles.container} style={getStyle(data.layout)}>
      <div
        style={{
          backgroundColor: data.background_color,
          ...(backgroundImage && {
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition:
              data.background_fit !== 'repeat' ? data.background_fit ?? 'left' : 'left',
            backgroundRepeat: data.background_fit === 'repeat' ? 'repeat' : 'no-repeat'
          })
        }}
        className={styles.background}
      >
        <CMSHeading {...data.heading} className={styles.heading} />
        <div
          className={classNames(
            styles[`col${data.number_of_columns}` as keyof typeof styles],
            styles.grid,
            { [styles.withHeading]: withHeading }
          )}
        >
          {data.items.map((item, index) => (
            <Item {...item} alignment={data.item_alignment} key={index} />
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

AppFooterContentWidget.model = appFooterContentWidgetModel;

export default AppFooterContentWidget;
